module.exports = __webpack_public_path__ + "img/AT0000002672606.a3a264f1.png";